import React from 'react';
import { useTranslation } from 'react-i18next';

// Import components
import { Logo } from 'components/elements';
// Import logic
import usePortalLogo from './usePortalLogo';

// Import helpers
import { WATERMARK_URL } from 'helpers/variables';

const PortalLogo = () => {
	const { t } = useTranslation();

	const { clearInstitution } = usePortalLogo();

	return (
		<Logo
			onClick={clearInstitution}
			ariaLabel={t('aria_header_logo_link')}
			title={t('aria_header_logo_link')}
			src={WATERMARK_URL}
			alt={t('common_portal_logo_title')}
		/>
	);
};

export default PortalLogo;
